const slugFallback = (slug?: string) => {
  if (!slug) return undefined
  if (slug?.startsWith('/') || slug?.startsWith('https://')) return slug
  return `/${slug}`
}

export default slugFallback
